/** Identity evidence is bound to the displayed name, never to career assertions.
 * Provider records stay private. Missing evidence and a changed name fail closed.
 * Do not transliterate, reorder tokens or remove accents to manufacture a match. */
export function resolveCvIdentityVerification(input: {
  displayedName: unknown;
  isUaePassVerified?: boolean | null;
  uaePassData?: unknown;
  uaePassLinkedAt?: Date | string | null;
  isOwnSubject?: boolean;
}) {
  const name = (value: unknown) => typeof value === 'string'
    ? value.normalize('NFC').trim().replace(/\s+/gu, ' ').toLocaleLowerCase('en-US') : '';
  const raw = input.uaePassData;
  const evidence = raw && typeof raw === 'object' && !Array.isArray(raw)
    ? raw as Record<string, unknown> : {};
  const displayed = name(input.displayedName);
  const verifiedNames = [evidence.fullNameEN, evidence.fullNameAR];
  for (const locale of ['EN', 'AR']) {
    const first = name(evidence[`firstName${locale}`]);
    const last = name(evidence[`lastName${locale}`]);
    if (first && last) verifiedNames.push(`${first} ${last}`);
  }
  const linkedAt = input.uaePassLinkedAt ? new Date(input.uaePassLinkedAt) : null;
  const verified = input.isOwnSubject !== false && input.isUaePassVerified === true
    && typeof evidence.uuid === 'string' && evidence.uuid.trim().length > 0
    && !!displayed && verifiedNames.some(value => name(value) === displayed)
    && linkedAt !== null && Number.isFinite(linkedAt.getTime());
  return {
    isUaePassVerified: verified,
    uaePassVerifiedAt: verified ? linkedAt!.toISOString() : null,
    verificationScope: 'identity_name' as const,
    careerClaimsVerified: false as const,
  };
}
